(function () {
	const searchModal = () => {
		setTimeout(function () {
			var modalEl = document.getElementById('search-modal');
			if (modalEl && !modalEl.classList.contains('active')) {
				modalEl.inert = true;
				modalEl.setAttribute('aria-hidden', 'true');
			}
		}, 1000);
		$(".search-modal-trigger,.search-modal__mask,.search-modal__close").click(
			function (e) {
				e.preventDefault();
				searchToggle()
			}
		);
	};
	$(document).on('keyup', function(e) {
		if ($("#search-modal").hasClass('active') && e.key == "Escape") {
			searchToggle()
		}
	});
	// Custom: trap focus within the search modal when it is active
	$(document).on('keydown', function(e) {
		if (!$("#search-modal").hasClass('active') || e.key !== "Tab") return;
		var modal = document.getElementById('search-modal');
		var focusable = modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])');
		if (focusable.length === 0) return;
		var first = focusable[0];
		var last = focusable[focusable.length - 1];
		if (e.shiftKey) {
			if (document.activeElement === first) {
				e.preventDefault();
				last.focus();
			}
		} else {
			if (document.activeElement === last) {
				e.preventDefault();
				first.focus();
			}
		}
	});
	function searchToggle(){
		$("#search-modal,.search-modal__mask").toggleClass("active");
		var isActive = $("#search-modal").hasClass('active');
		// Custom: sync aria-expanded on search trigger button
		$(".search-modal-trigger").attr('aria-expanded', isActive ? 'true' : 'false');
		// Make siblings of the modal inert when open, restore when closed
		$("#search-modal").siblings().each(function () {
			if (isActive) {
				$(this).attr('aria-hidden', 'true');
				this.inert = true;
			} else {
				$(this).removeAttr('aria-hidden');
				this.inert = false;
			}
		});
		var modalEl = document.getElementById('search-modal');
		modalEl.inert = !isActive;
		modalEl.setAttribute('aria-hidden', isActive ? 'false' : 'true');
		if (isActive) {
			$("#search-modal").find('.search__input').focus();
		} else {
			$(".search-modal-trigger").focus();
		}
		$('body').toggleClass("overflow-hidden")
	}
	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
